import request from 'admin-ng/util/request-promise';
import {PROGRAMS} from '.';

export const all = params => request(PROGRAMS, 'get', params);
export const one = id => request(`${PROGRAMS}${id}`, 'get');
export const update = (id, params) =>
  request(`${PROGRAMS}${id}`, 'put', params);
export const create = params => request(PROGRAMS, 'post', params);
